const range = document.querySelector('input[type="range"]');
const bubble = document.querySelector('.js-bubble');

range.addEventListener('input', () => {
    setBubble(range, bubble);
});

function setBubble(range, bubble) {
    const val = range.value;
    const min = range.min ? range.min : 0;
    const max = range.max ? range.max : 100;
    const newVal = Number(((val - min) * 100) / (max - min));
    bubble.innerHTML = val;

    // Sorta magic numbers based on size of the native UI thumb
    bubble.style.left = `calc(${newVal}% - ${bubble.clientWidth / 100 * newVal}px)`;
}

setBubble(range, bubble);